const DIAGNOSED_PROFILE_NAME = {
    seed: 'Semilla',
    explorer: 'Explorador',
    patrimonial: 'Constructor Patrimonial',
    strategic: 'Inversionista Estratégico'
};
export default DIAGNOSED_PROFILE_NAME;
